import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-switcher",
  templateUrl: "./switcher.component.html",
  styleUrls: ["./switcher.component.scss"],
})
export class SwitcherComponent implements OnInit, OnChanges {
  @Input() items: any[] = [];
  @Input() activeItem = "";

  @Output() switcherChange = new EventEmitter<string>();

  currVal = "";

  uniqId = Math.floor(Math.random() * 1000);
  constructor() {}

  ngOnInit(): void {
    this.init();
  }

  ngOnChanges() {
    this.init();
  }

  init() {
    if (this.activeItem) {
      this.currVal = this.activeItem;
    } else {
      this.currVal = this.items[0].value;
    }
  }

  change(e: any) {
    this.switcherChange.emit(this.currVal);
  }
}
